import type React from 'react';
import { createContext } from 'react';

export interface CrispContextValue {
	setShowLauncher: React.Dispatch<React.SetStateAction<boolean>>;
	handleOpenLauncher: React.MouseEventHandler;
}

export default createContext<CrispContextValue>(undefined!);
